export default __webpack_public_path__ + "32743a4d0c4282e2070b574e6e5038ab.ttf";